import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const AdminLeadTrack = () => {
  const [leads, setLeads] = useState([
    { id: 1, name: 'John Doe', status: 'Pending' },
    { id: 2, name: 'Jane Smith', status: 'Demo Fixed' },
    { id: 3, name: 'Michael Brown', status: 'Demo Completed' },
    { id: 4, name: 'Alice Johnson', status: 'Demo Converted' },
    { id: 5, name: 'David Lee', status: 'Lost' }
  ]);

  const [metrics, setMetrics] = useState({
    conversionRate: 0,
    pendingLeads: 0,
    completedLeads: 0
  });

  useEffect(() => {
    const totalLeads = leads.length;
    const pendingLeads = leads.filter(lead => lead.status === 'Pending').length;
    const completedLeads = leads.filter(lead => lead.status === 'Demo Converted').length;
    const conversionRate = ((completedLeads / totalLeads) * 100).toFixed(2);

    setMetrics({
      conversionRate,
      pendingLeads,
      completedLeads
    });
  }, [leads]);

  return (
    <div className='container mt-5'>
      <h3>Lead Status Tracking</h3>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Lead Name</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {leads.map((lead) => (
              <TableRow key={lead.id}>
                <TableCell>{lead.name}</TableCell>
                <TableCell>{lead.status}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <div style={{ marginTop: '20px' }}>
        <h4>Lead Metrics</h4>
        <p>Lead Conversion Rate: {metrics.conversionRate}%</p>
        <p>Pending Leads: {metrics.pendingLeads}</p>
        <p>Completed Leads: {metrics.completedLeads}</p>
      </div>
    </div>
  );
};

export default AdminLeadTrack;
